//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../no/Builder.js";
import "../Features/Features.ShipDesign.RoomAttributeListBuilder.js";
import "../no/SelectDisplayableObjectList.js";
import "../no/RegionPointList.js";
import "../no/ugmath.js";
import "../no/SelectObjectList.js";
import "../no/Features.js";
import "../no/ObjectList.js";
let d=[[[1,"AttributeList",0,"Features.ShipDesign.RoomAttributeListBuilder",0],[1,"Boundaries",0,"SelectDisplayableObjectList",0],[0,"IsIgnored",1,0],[1,"Regions",0,"RegionPointList",0]],[[["nRegion"],"CreateRegions",{R_:{regionBodies:"Body[]"}},0,0],[["regionPoints"],"SetRegionPoints",{},1,0],[["index"],"GetRegionBody",{R_:{region_body:"Body"}},1,0]],[]];
SPLM.Features.ShipDesign.CompartmentBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.CompartmentBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;